export type ValidationI18n = {
	required: string;
	minLength: (min: number) => string;
	maxLength: (max: number) => string;
	numericMin: (min: number) => string;
	numericMax: (max: number) => string;
	numericExclusiveMin: (min: number) => string;
	numericExclusiveMax: (max: number) => string;
	mustSelectAtLeastOne: string;
	invalidFormat: string;
	notTrimmed: string;
	dateMustBeAfter: (date: string) => string;
	dateMustBeBefore: (date: string) => string;
};

export const DEFAULT_VALIDATION_I18N: ValidationI18n = {
	required: 'Required',
	minLength: (min) => `Must be at least ${min} characters`,
	maxLength: (max) => `Must be at most ${max} characters`,
	numericMin: (min) => `Must be greater than or equal to ${min}`,
	numericMax: (max) => `Must be less than or equal to ${max}`,
	numericExclusiveMin: (min) => `Must be greater than ${min}`,
	numericExclusiveMax: (max) => `Must be less than ${max}`,
	mustSelectAtLeastOne: 'Must select at least one option',
	invalidFormat: 'Invalid format',
	notTrimmed: 'Must not have leading or trailing whitespace',
	dateMustBeAfter: (date) => `Must be after ${date}`,
	dateMustBeBefore: (date) => `Must be before ${date}`
};

export function createValidationI18n(overrides?: Partial<ValidationI18n>): ValidationI18n {
	if (!overrides) return { ...DEFAULT_VALIDATION_I18N };
	return { ...DEFAULT_VALIDATION_I18N, ...overrides };
}
